import React from "react";
import { Button, ButtonProps } from "../button/Button";
import { LinkButton } from "../button/LinkButton";
import { Link } from "../Link";
import { TooltipTheOneWrapper } from "../TooltipTheOne";
import { CopyButton } from "./CopyLinkButton";
import { Flex } from "./FlexHelpers";
import { ButtonVariant } from "../button/Shared";

type LinkWithCopyButtonProps =
{
    url: string,
    buttonVariant?: ButtonVariant,
    buttonText?: string,
    extraButtons?: ButtonProps[],
    showAsGoTo?:boolean,
    disabled?:boolean
};

export function LinkWithCopyButton(props: LinkWithCopyButtonProps): JSX.Element 
{
    return (
        
        <Flex flexDirection="row" gap={10} alignItems="center" style={{ width: '100%', minWidth: 0 }}>

            {!props.showAsGoTo &&
                <div style={{ minWidth: 0, flex: '1 1 0' }}>
                    <Link href={props.url} target="_blank" rel="noopener noreferrer" style={{ display: 'block', width: '100%', overflow: 'hidden' }} title={props.url}>
                        {props.url}
                    </Link>
                </div>
            }

            {props.showAsGoTo &&
                <TooltipTheOneWrapper tooltipContent="Åbn link i ny fane">
                    <LinkButton variant="text" icon="interface_actions_externalLink" href={props.url} target="_blank" rel="noopener noreferrer" />
                </TooltipTheOneWrapper>
            }

            <div style={{ flexShrink: 0 }}>
                <CopyButton
                    value={props.url}
                    disabled={props.disabled}
                    text={props.buttonText}
                    variant={props.buttonVariant}
                />
            </div>
            
            {props.extraButtons && props.extraButtons.map((b, i) =>
                <div key={i} style={{ flexShrink: 0 }}>
                    <Button {...b} />
                </div>
            )}
        </Flex>
    )
}